import { useSelector } from 'react-redux';
import { isAllowedPriceDiffOverquota, isPriceDifferentiation } from 'reactApp/appHelpers/featuresHelpers/features/priceDifferentiation';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { isCloudOrMailOrApiOverQuota } from 'reactApp/modules/userQuota/overquota.helpers';
import {
    getMultiTariffMobilePriceDiff,
    getMultiTariffMobileProductsSpacesListByTab,
} from 'reactApp/sections/QuotaLanding/MultiTariffsListMobile/MultiTariffsListMobile.selectors';
import type { RootState } from 'reactApp/store';

export const useGetProductsSpaces = () => {
    const isPaidUser = useSelector(UserSelectors.isPaidUser);
    const isOverquota = useSelector(isCloudOrMailOrApiOverQuota);
    const isCorpUser = useSelector(UserSelectors.isCorpUser);

    return useSelector((state: RootState) => {
        // tempexp_19499-start
        if (!isCorpUser && !isPaidUser && isPriceDifferentiation && (!isOverquota || (isAllowedPriceDiffOverquota && isOverquota))) {
            return getMultiTariffMobilePriceDiff(state);
        }
        // tempexp_19499-end

        // !IMPORTANT. Не расширяем оригинальный селектор. Если для эксперимента нужны другие тарифы/цены - заводим отдельный.
        return getMultiTariffMobileProductsSpacesListByTab(state);
    });
};
